import { render, staticRenderFns } from "./DemographicPermissions.vue?vue&type=template&id=651fac0d&scoped=true"
import script from "./DemographicPermissions.vue?vue&type=script&lang=js"
export * from "./DemographicPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fac0d",
  null
  
)

export default component.exports